module.exports = __webpack_public_path__ + "static/img/HOME1 768x1024.8fef6fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/home/HOME1 768x1024.jpg
// module id = lOiO
// module chunks = 47